import { render, staticRenderFns } from "./ExchangeRateList.vue?vue&type=template&id=2df69003&scoped=true"
import script from "./ExchangeRateList.vue?vue&type=script&lang=js"
export * from "./ExchangeRateList.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRateList.vue?vue&type=style&index=0&id=2df69003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df69003",
  null
  
)

export default component.exports